import React, { PropTypes } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { Button } from 'react-bootstrap';
import TextareaControl from './../../FormTemplate/TextareaControl';

import RenderItemList from './FormHelper/RenderItemList';

class LostAdjustmentForm extends React.Component {
   render() {
      const { handleSubmit, saveLostAdjustment, items, submitting, pristine, invalid, error } = this.props;
      return (
         <form noValidate="true" autoComplete="off" onSubmit={handleSubmit(saveLostAdjustment)} >
            <FieldArray items={items} name="items" component={RenderItemList} />
            {error && <strong className="input-validation-error" >{error}</strong>}

            <Field name="memo" label="Memo" component={TextareaControl} />
            <Button type="submit" bsStyle="success" block
                    disabled={submitting || pristine || invalid} >Save</Button>
         </form>
      );
   }
}
LostAdjustmentForm.propTypes = {
   handleSubmit: PropTypes.func,
   saveLostAdjustment: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ])
};


LostAdjustmentForm = reduxForm({ // eslint-disable-line
   form: 'lostAdjustmentForm'
})(LostAdjustmentForm);

// const selector = formValueSelector('newSaleForm');
//
// LostAdjustmentForm = connect(state => { // eslint-disable-line
//    const items = selector(state, 'items');
//    const contact_id = selector(state, 'contact_id');
//    return {
//       items,
//       contact_id
//    };
// })(LostAdjustmentForm);

export default LostAdjustmentForm;



/** WEBPACK FOOTER **
 ** ./src/components/StockManagement/LostAdjustment/LostAdjustmentForm.js
 **/